import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [],
  selector: 'ui-losses-info-card',
  template: `
    <div
      class="bg-white shadow-md px-6 py-5 rounded-lg h-full grid grid-cols-12"
    >
      <div class="col-span-9">
        <p class="text-neutral-7 mb-4 text-xs">{{ title() }}</p>
        <p class="text-[32px]">{{ value() }}</p>
      </div>
      @if (hasPercentage()) {
        <div class="col-span-3 flex items-center justify-end">
          <span
            class="text-amber-700 bg-amber-100 rounded-full px-2 py-1 font-medium text-2xl"
            >{{ percentage() }}</span
          >
        </div>
      }
    </div>
  `,
})
export class LossesInfoCardComponent {
  hasPercentage = input<boolean>(false);
  title = input<string>();
  value = input<string | null>(null);
  percentage = input<string>();
}
